import { createSlice, PayloadAction } from '@reduxjs/toolkit';

type DeletedSessionsState = {
  deletedListIds: Array<string>;
};

const initialState: DeletedSessionsState = {
  deletedListIds: [],
};

export const deletedSessionsSlice = createSlice({
  name: 'deletedSessions',
  initialState,
  reducers: {
    addDeletedSessionId: (state, action: PayloadAction<string>) => {
      state.deletedListIds.push(action.payload);
    },
  },
});

export const { addDeletedSessionId } = deletedSessionsSlice.actions;
export default deletedSessionsSlice.reducer;
